
import React, { useState } from "react";
import {
FaUser,
FaEnvelope,
FaIdCard,
FaBriefcase,
FaLock,
FaPhone,
FaBuilding,
FaUpload,
FaCamera,
} from "react-icons/fa";

import { Link, useNavigate } from "react-router-dom";

function RegisterTenagaKesehatan() {

const navigate = useNavigate();

const [formData, setFormData] = useState({
NamaLengkap: "",
email_tenagakesehatan: "",
username_tenagakesehatan: "",
password: "",
NoTeleponeTK: "",
NoSTR: "",
Profesi: "",
AlamatFasilitasKesehatan: "",
NIP: "",
dokumen: null,
foto_verifikasi: null,
agree: false,
});

const handleChange = (e) => {
const { name, value, type, checked, files } = e.target;

setFormData((prev) => ({
...prev,
[name]:
type === "checkbox"
? checked
: type === "file"
? files[0]
: value,
}));
};

const handleSubmit = async (e) => {
e.preventDefault();

if (!formData.agree) {
alert("Harap setujui Terms & Privacy Policy");
return;
}

if (!formData.dokumen) {
alert("Upload dokumen verifikasi");
return;
}

if (!formData.foto_verifikasi) {
alert("Upload selfie verifikasi");
return;
}

try {
const sendData = new FormData();

Object.entries(formData).forEach(([key, value]) => {
sendData.append(key, value);
});

const res = await fetch(
"https://api-tibismart.tifpsdku.com/api/register-tenaga-kesehatan",
{
method: "POST",
body: sendData,
}
);

const data = await res.json();

if (res.ok) {
alert("Registrasi berhasil");
navigate("/logintenagakesehatan");
} else {
alert(data.message || "Registrasi gagal");
}
} catch (err) {
alert("Tidak dapat terhubung ke server");
}
};

const Input = ({ icon: Icon, name, placeholder, type = "text" }) => (
<div className="bg-[#E0E0E0] rounded-xl px-4 flex items-center">
<Icon className="text-gray-500" />
<input
className="w-full bg-transparent outline-none py-4 px-3"
name={name}
type={type}
placeholder={placeholder}
value={formData[name]}
onChange={handleChange}
/>
</div>
);

return (
<div className="min-h-screen bg-white flex justify-center px-6 py-10">
<div className="w-full max-w-md">

<div className="text-center mb-8">
<img
src="/assets/logobaruTibiSmart.png"
className="w-36 mx-auto"
/>
<h1 className="text-3xl font-bold text-[#64B5F6] mt-4">
Register
</h1>
</div>

<form className="space-y-3" onSubmit={handleSubmit}>

<Input icon={FaUser} name="NamaLengkap" placeholder="Nama Lengkap" />
<Input icon={FaEnvelope} name="email_tenagakesehatan" placeholder="Email" type="email" />
<Input icon={FaLock} name="password" placeholder="Password" type="password" />
<Input icon={FaPhone} name="NoTeleponeTK" placeholder="Nomor Telepon" />
<Input icon={FaUser} name="username_tenagakesehatan" placeholder="Username" />
<Input icon={FaIdCard} name="NoSTR" placeholder="Nomor STR" />
<Input icon={FaBriefcase} name="Profesi" placeholder="Profesi" />
<Input icon={FaBuilding} name="AlamatFasilitasKesehatan" placeholder="Tempat Kerja" />
<Input icon={FaIdCard} name="NIP" placeholder="NIP" />

{/* FILE */}
<div className="bg-[#E0E0E0] rounded-xl p-4">
<label className="flex gap-3 cursor-pointer">
<FaUpload />
<span>
{formData.dokumen ? formData.dokumen.name : "Upload Dokumen"}
</span>
<input hidden type="file" name="dokumen" onChange={handleChange} />
</label>
</div>

{/* SELFIE */}
<div className="bg-[#F5FAFF] border border-[#64B5F6] rounded-2xl p-5 text-center">
<FaCamera className="mx-auto text-[#64B5F6] text-3xl" />
<p className="font-semibold mt-3">Verifikasi Wajah</p>

<label className="mt-4 inline-block bg-[#64B5F6] text-white px-5 py-3 rounded-xl cursor-pointer">
Ambil Selfie
<input hidden type="file" accept="image/*" capture="user" name="foto_verifikasi" onChange={handleChange} />
</label>
</div>

{/* TERMS */}
<label className="flex gap-3 items-center">
<input type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} />
<span>I agree to Terms & Privacy Policy</span>
</label>

<button className="w-full bg-[#64B5F6] text-white py-4 rounded-xl font-semibold">
Register
</button>

<p className="text-center">
Already have account?
<Link className="ml-2 text-[#64B5F6] font-semibold" to="/logintenagakesehatan">
Sign In
</Link>
</p>

</form>

</div>
</div>
);
}

export default RegisterTenagaKesehatan;